<template>
    <div class="box">
        <div class="tabbar" v-if="!isApp" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logo.png" alt="" />
        </div>
        <div class="top-box">
            <img class="banner" src="/subject/careFree/banner.png" alt="" />
            <img class="banners" src="/subject/careFree/wap/banner.png" alt="" />
            <div :class="navBarFixed ? 'btncount count' : 'btncount '" @click="joinActivity">

            </div>
            <div :class="navBarFixed ? 'top-list' : 'top-list tps'">
                <img src="/subject/careFree/slider.png" alt="">
                <div class="times">
                    <span>{{ day }}</span>天
                    <span>{{ hour }}</span>时
                    <span>{{ minute }}</span>分
                    <span>{{ second }}</span>秒
                </div>
            </div>
            <div :class="navBarFixed ? 'top-list1 tp' : isApp ? 'top-list1 tp1' : 'top-list1'">
                <div style="position: relative;">
                    <img src="/subject/careFree/wap/slider.png" alt="">
                    <div :class="navBarFixed || isApp ? 'times1' : 'times'">
                        <span class="hour">{{ day }}</span>
                        <span class="hour">{{ hour }}</span>
                        <span class="minute">{{ minute }}</span>
                        <span class="second">{{ second }}</span>
                    </div>
                </div>



            </div>
        </div>

        <div class="content">
            <div class="part">
                <div class="part1">
                    <div>

                        <div class="img-box1">

                            <div>
                                <span>入金≥$1000</span>
                                <img src="/subject/careFree/coupon1.png" alt="">
                            </div>
                            <div>
                                <span>入金≥$5000</span>
                                <img src="/subject/careFree/coupon2.png" alt="">
                            </div>
                            <div>
                                <span>入金≥$500</span>
                                <img src="/subject/careFree/coupon.png" alt="">
                            </div>
                        </div>

                        <img class="cont" src="/subject/careFree/cont.png" alt="">
                        <div class="anniu">
                            <div class="anniu-div" @click="live800"></div>

                            <img class="anniu-img" @click="joinActivity" src="/subject/careFree/join.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="wappart1">

                    <div class="part-list">
                        <div class="lists">
                            <span>入金≥$500</span>
                            <img src="/subject/careFree/wap/coupon.png" alt="">
                        </div>
                        <div class="lists">
                            <span>入金≥$1000</span>
                            <img src="/subject/careFree/wap/coupon1.png" alt="">
                        </div>
                        <div class="lists" style="margin-top: 20px;">
                            <span>入金≥$5000</span>
                            <img src="/subject/careFree/wap/coupon2.png" alt="">
                        </div>
                        <div>

                            <div class="lists1">
                                <img src="/subject/careFree/wap/tick.png" alt="">
                                <span>定档后立即生效
                                </span>
                            </div>

                            <div class="lists1">
                                <img src="/subject/careFree/wap/tick.png" alt="">
                                <span>
                                    持续保障15天
                                </span>
                            </div>

                            <div class="lists1">
                                <img src="/subject/careFree/wap/tick.png" alt="">
                                <span>
                                    亏损达标自动入账</span>
                            </div>




                        </div>
                    </div>
                    <div class="anniu">
                        <div class="anniu-div" @click="live800"></div>

                        <img class="anniu-img" @click="joinActivity" src="/subject/careFree/join.png" alt="">
                    </div>

                </div>
                <div class="part2 clearfix">
                    <img class="step" src="/subject/careFree/step.png" alt="">
                    <div class="progress">
                        <img src="/subject/careFree/circle.png" alt="">

                        <div class="progress-cont">
                            <p>A客户报名后，72小时内分别充值500美元、300美元、400美元。
                                净<span>入金1200美元</span>，最后定档获得无忧券额度300美元。</p>
                            <p>
                                在之后的15天，A客户积极交易，但行情不佳亏损305美元。最终
                                A客户账户获得<span>300美元现金补贴</span>，个人仅承担5美元损失。
                            </p>
                        </div>
                    </div>
                    <div class="anniu">
                        <div class="anniu-div" @click="live800"></div>


                        <img class="anniu-img" @click="joinActivity" src="/subject/careFree/join.png" alt="">
                    </div>
                    <div class="ruleActive">
                        <h2>活动规则</h2>
                        <p>参与条件</p>
                        <span>1、超过1个自然月未活跃的平台已激活用户</span>
                        <span>2、需在活动页报名，限前1000名用户，先到先得。</span>
                        <p>参与方式</p>
                        1、在指定页面报名。
                        <span>2、报名后72小时内进行入金充值，获取对应档位无忧券，详情见下表。</span>
                        <div class="detailTable">
                            <el-table :data="tableData" stripe border style="width: 1130px;margin: 0 auto;"
                                :header-cell-style="{ textAlign: 'center', color: '#000', border: 'none' }"
                                :header-row-style="{ height: '80px', background: 'linear-gradient(to right, #ffe9bf, #ffd9a2)' }"
                                :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                                <el-table-column prop="date" label="活动档位" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="name" label="72H净入金" min-width="30%">
                                </el-table-column>
                                <el-table-column prop="address" label="无忧券额度" min-width="40%">
                                </el-table-column>
                            </el-table>
                        </div>
                        <span>3、无忧券于报名72小时后定档生效，自报名起，15天内可在平台开平仓交易，如果亏损达到无忧券额度，即可获得等额美元现金。</span>

                        <p>无忧券使用规则</p>
                        <span>1、有效期内累计交易亏损达到无忧券额度，即可获得对应等额的美元现金，现金将自动打入账户余额。</span>
                        <span>2、得到的美元现金可当真实资金使用，可交易可提现，提现时无手数要求。</span>
                        <span>3、无忧券有效期15天，过期失效。</span>
                        <span>4、无忧券仅能获得一次，无法重复获取。</span>
                        <p>注意事项</p>
                        <span> 1、客户参与活动需在本公司开立真实交易账户。</span>
                        <span>2、交易手数计算：开仓一手平仓一手，如此来回算一手。</span>
                        <span>3、本活动本公司客户仅有一次机会参与，不可重复领取。</span>
                        <span>4、本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。</span>
                        <span>5、若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。</span>


                    </div>


                </div>
                <div class="wappart2 clearfix">
                    <img class="step" src="/subject/careFree/wap/step.png" alt="">
                    <div class="progress">
                        <div class="progress-cont">
                            <p>A客户报名后，72小时内分别充值500美元、300美元、400美元。
                                净<span>入金1200美元</span>，最后定档获得无忧券额度300美元。</p>
                            <p class="titles">
                                在之后的15天，A客户积极交易，但行情不佳亏损305美元。最终
                                A客户账户获得<span>300美元现金补贴</span>，个人仅承担5美元损失。
                            </p>
                        </div>
                        <img src="/subject/careFree/wap/progress.png" alt="">


                    </div>
                    <div class="anniu">
                        <div class="anniu-div" @click="live800"></div>


                        <img class="anniu-img" @click="joinActivity" src="/subject/careFree/join.png" alt="">
                    </div>
                    <div class="ruleActive">
                        <h2>活动规则</h2>
                        <p>参与条件</p>
                        <span>1、超过1个自然月未交易的平台已激活用户</span>
                        <span>2、需在活动页报名，限前1000名用户，先到先得。</span>
                        <p>参与方式</p>
                        1、在指定页面报名。
                        <span>2、报名后72小时内进行入金充值，获取对应档位无忧券，详情见下表。</span>
                        <div class="detailTable">
                            <el-table :data="tableData" stripe border style="width: 1130px;margin: 0 auto;"
                                :header-cell-style="{ textAlign: 'center', fontSize: '12px', color: '#000', border: 'none' }"
                                :header-row-style="{ height: '40px', background: 'linear-gradient(to right, #ffe9bf, #ffd9a2)' }"
                                :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                                <el-table-column prop="date" label="活动档位" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="name" label="72H净入金" min-width="30%">
                                </el-table-column>
                                <el-table-column prop="address" label="无忧券额度" min-width="40%">
                                </el-table-column>
                            </el-table>
                        </div>
                        <span>3、无忧券于报名72小时后定档生效，生效后，15天内可在平台开平仓交易，如果亏损达到无忧券额度，即可获得等额美元现金。</span>

                        <p>无忧券使用规则</p>
                        <span>1、有效期内累计交易亏损达到无忧券额度，即可获得对应等额的美元现金，现金将自动打入账户余额。</span>
                        <span>2、得到的美元现金可当真实资金使用，可交易可提现，提现时无手数要求。</span>
                        <span>3、无忧券有效期15天，过期失效。</span>
                        <span>4、无忧券仅能获得一次，无法重复获取。</span>
                        <p>注意事项</p>
                        <span> 1、客户参与活动需在本公司开立真实交易账户。</span>
                        <span>2、交易手数计算：开仓一手平仓一手，如此来回算一手。</span>
                        <span>3、本活动本公司客户仅有一次机会参与，不可重复领取。</span>
                        <span>4、本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。</span>

                    </div>


                </div>

            </div>

        </div>


        <!-- 报名活动 -->
        <el-dialog :visible.sync="showUnderLog" :showClose="false" width="0px" height="0" style="padding: 0;">

            <!-- 成功 -->
            <div class="underlog">
                <img class="closer" @click="closeDialog" src="/subject/careFree/close.png" alt="" />

                <div class="conts" v-if="newSubmit">
                    <p>新用户推荐参与首充活动， </p>

                    <p class="tit">您可以前往【APP-我的-活动中心-首充多少送多少】了解。</p>
                    <p class="weight"><span @click="live800">联系客服</span>下载官方APP</p>
                </div>
                <div class="conts" v-if="successShow">
                    <img class="success" src="/subject/careFree/success.png" alt="">
                    <p class="tits">报名成功!</p>
                    <p class="tit">您可以前往【APP-我的-活动中心-交易无忧券】查看参与进度。</p>
                    <p class="weight" v-if="!isApp"><span @click="live800">联系客服</span>下载官方APP</p>

                </div>
                <div class="conts" v-if="failShow">
                    <img class="fail" src="/subject/careFree/fail.png" alt="">
                    <p class="tits">报名失败</p>
                    <p class="title">
                        您正在参与首充活动，有机会得<span>$20000+￥1588</span>的新人福利，推荐首充结束后再来~
                    </p>
                    <p>更多报名问题请咨询客服</p>
                    <div>
                        <img src="/subject/careFree/dialog.png" @click="live800" alt="">
                        <div class="know" @click="closeDialog">
                            我已了解
                        </div>
                    </div>
                </div>
            </div>


        </el-dialog>



        <!-- 登录注册 -->
        <el-dialog :visible.sync="loginDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
            <div class="loginDialogs">
                <img class="closer" @click="closeHistory" src="/subject/careFree/close.png" alt="" />
                <div class="login">
                    <div class="logintitle">
                        <div>
                            <span :class="actives == 0 ? 'commons' : ''" @click="selectlogin(0)">登录</span>
                            <div :class="actives == 0 ? 'line' : ''"></div>
                        </div>
                        <div>
                            <span :class="actives == 1 ? 'commons' : ''" @click="selectlogin(1)">注册</span>
                            <div :class="actives == 1 ? 'line' : ''"></div>

                        </div>
                    </div>

                    <div class="interactive">


                        <input v-if="isNumber" ref="inputElement" type="text" v-model="form.phone"
                            placeholder="请输入交易账号/手机号" @blur="changePhone" />
                        <input v-model="form.phone" v-else ref="inputElement" type="text" placeholder="请输入手机号"
                            @blur="changePhone" />

                        <div class="codeBox" v-if="isNumber">
                            <input v-model="form.password" placeholder="请输入密码" show-password maxlength="20" />
                        </div>
                        <div class="codeBox" v-else>
                            <input v-model="form.code" type="text" placeholder="请输入验证码" />
                            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                            <span v-else>重新获取({{ verSecond }})</span>
                        </div>
                        <div v-if="actives == 0" class="titleLogin">
                            <span v-if="isNumber" @click="selectAccount1">验证码登录</span>

                            <span v-else @click="selectAccount">账号登录</span>
                            <img v-if="isNumber" @click="selectAccount1" src="/subject/careFree/arrow.png" alt="">
                            <img v-else @click="selectAccount" src="/subject/careFree/arrow.png" alt="">

                        </div>
                        <div class="buttom" @click="submit1(form)" v-if="isNumber">
                            <img src="/subject/careFree/submit.png" alt="">

                        </div>
                        <div class="buttom" @click="submit(form)" v-else>
                            <img src="/subject/careFree/submit.png" alt="">
                        </div>
                    </div>

                </div>

            </div>
        </el-dialog>

    </div>
</template>

<script>



import Qrcode from "@/component/QrCode/index.vue";
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { postLogin } from '@/apis/user';
import { encryptCBC } from "@/utils/IMEI";
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { Loading } from 'element-ui';
import { appLy, sendTicket, usercenter } from '@/apis/active'
import { getActicityParam } from '@/apis/transfer'
import { data } from "jquery";
import { getTeacherList, getTime } from "../../../../api/subject/hdtime";


export default {
    components: {

        Qrcode,
    },
    mixins: [userSign],

    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            timer: null,
            tableData: [
                {
                    date: 'A1',
                    name: '$500',
                    address: '$150'
                },
                {
                    date: 'A2',
                    name: '$1000',
                    address: '$300'
                },
                {
                    date: 'A3',
                    name: '$5000',
                    address: '$1000'
                },
            ],

            loginDialog: false,//登录注册弹框
            actives: 0,
            isApp: false,
            isLogin: false,
            isPC: true,
            isNumber: false,//是否账号密码登录
            fullscreenLoading: false,
            // 报名弹框
            showUnderLog: false,

            // 新用户
            newSubmit: false,
            // 成功
            successShow: false,
            // 失败
            failShow: false,
            day: '00',
            hour: '00',
            minute: '00',
            second: '00',
            curStartTime: '',//结束时间
            activeCont: {},//活动详情
            joinList: [],//参与活动
            userinfo: {},//用户信息
            // 未登录倒计时
            form1: {
                key: "BPCountdown",
            },
            isNew: false,//活动中心进入
            loginStatus : false,//未登录

        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };




    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                this.$emit("controlShow", false);

            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);

        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.isPC = false
            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            // 用户中心首冲进入
            if (this.$route.query.type) {
                localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=') ? str.split("a=")[1] : '');

                this.isNew = true
                this.getActivityInfo()
            }

            console.log('token', token)
            if (token) {
                const str = this.$route.query.isApp
                this.isLogin = true
                //h5携带参数截取
                

                localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=') ? str.split("a=")[1] : '');
                this.userKey = localStorage.getItem('token');
                this.loginStatus = false
                this.getCountdown()

            } else {
                this.isLogin = false
                this.loginStatus = true
                this.getTimes()

            }
        }

        else {
            if (localStorage.getItem('token')) {

                this.userKey = localStorage.getItem('token');
                this.loginStatus = false

                this.getCountdown()


            } else {
                this.loginStatus = true

                this.getTimes()
                
            }
        }
        console.log(this.getDateChange(1743642000000))
    },
    methods: {
        getTimes(){
           getTime(this.form1).then(res=>{
              console.log(res)
               this.curStartTime = new Date(res.Data).getTime() 
               this.updateCountdown();
               setInterval(this.updateCountdown, 1000);
           })
        },
        ...mapActions('common', {
            getTradeWapLink: 'getTradeWapLink',
        }),
        // 去登录
        async toLogin() {
            // 在安卓app
            if (window.android) {
                window.android.gotoLogin();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoLogin()
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
        },
        // 获取倒计时
        getCountdown() {
            usercenter({ activityid: '882' }).then(res => {
                console.log('11111111', res)
                this.activeCont = res.content
                this.curStartTime = res.content.activityendtime
                this.updateCountdown();
                setInterval(this.updateCountdown, 1000);
            })
        },
        // 倒计时
        updateCountdown() {
            const today = new Date()
            const endOfMonth = this.isNew ? new Date(this.curStartTime + 8 * 3600000 + 7 * 24 * 3600000).getTime() : this.loginStatus ? new Date(this.curStartTime ).getTime() : new Date(this.curStartTime + 8 * 3600000).getTime();
            let timeLeft = endOfMonth - today;
            if (timeLeft <= 0) {
                timeLeft = 0;
                clearInterval(this.timer);
            }
            this.day = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(
                2,
                "0"
            );
            this.hour = String(
                Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            ).padStart(2, "0");
            this.minute = String(
                Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
            ).padStart(2, "0");
            this.second = String(
                Math.floor((timeLeft % (1000 * 60)) / 1000)
            ).padStart(2, "0");
        },



        // 参加活动
        joinActivity() {
            // 未登录
            if (!localStorage.getItem('token')) {
                // 是否APP
                if (this.isApp) {
                    this.toLogin()
                } else {
                    this.actives = 0

                    this.loginDialog = true
                }

            } else {

                this.getuserInfo()


            }
        },
        //活动中心获取用户信息
        getActivityInfo() {
            const iv = 'LIQABxPFN04DhnkX';
            const params = {
                accountid: localStorage.getItem('account'),

            }
            getActicityParam('findbyaccountid', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('用户信息-------', res)
                let list = res.activityuserinfos

                if (list && list.length > 0) {

                    let timelist = list.filter(item => item.code === 'AdvAmt')
                    if (timelist.length > 0) {
                        let time = timelist[0].accountactivityendtime//首入结束时间
                        let times = new Date()
                        const time1 = this.constdiffInDays(time, times)
                        console.log(time1)
                        if (this.isNew && time1 >= 0 && time1 <= 7) {
                            this.curStartTime = timelist[0].accountactivityendtime
                            this.updateCountdown();
                            setInterval(this.updateCountdown, 1000);

                            return
                        }

                    }



                }


            })
        },

        // 获取用户信息
        getuserInfo() {
            const iv = 'LIQABxPFN04DhnkX';
            const params = {
                accountid: localStorage.getItem('account'),

            }
            getActicityParam('findbyaccountid', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('用户信息-------', res)
                let list = res.activityuserinfos

                // 用户是否首次入金
                if (this.userinfo.isFirst == 0) {
                    this.showUnderLog = true
                    this.newSubmit = true
               
                } 
                else {


                    if (list && list.length > 0) {
                        this.joinList = list
                        let join = list.filter(item => item.code === 'PayLosses' && item.accountactivitystatus == 2)
                        
                        let join2 = list.filter(item => item.code === 'PayLosses' && item.activityid == 882)
                        // 如果包赔劵活动已结束或者同时有
                        if (join.length > 0 ||  join2.length > 0) {
                            // let time2 = this.constdiffInDays(join[0].accountactivityendtime, times)
                            this.attendActivity('882')
                            return

                        }
                        let timelist = list.filter(item => item.code === 'AdvAmt')
                        if (timelist.length > 0) {
                            let time = timelist[0].accountactivityendtime//首入结束时间
                            let times = new Date()
                            const time1 = this.constdiffInDays(time, times)
                            console.log(time1)
                            if (this.isNew && time1 >= 0 && time1 <= 7) {

                                this.attendActivity('882')
                                return
                            }

                            
                        }

                        // 正在参与
                        const filteredArray1 = list.filter(item => item.code === 'AdvAmt' && item.accountactivitystatusname == '进行中');


                        // 正在参与活动
                        if (filteredArray1.length > 0) {
                            

                            this.showUnderLog = true
                            this.failShow = true

                        } else {

                            this.attendActivity('882')

                        }


                    }
                    // 新用户没参加赠金活动入金是0
                    if (!list) {

                        this.attendActivity('882')
                    }
                }

            })
        },

        // 报名成功
        attendActivity(id) {
            // 已经加入无忧劵活动
            // const filteredArray1 = this.joinList.filter(item => item.code === 'PayLosses' && item.accountactivitystatusname == '进行中');

            // if (filteredArray1.length > 0) {
            //     this.$message({
            //         message: '您已加入该活动！',
            //         type: 'warning',
            //     });
            //     // return
            // }
            appLy({ activityid: id }).then(res => {
                console.log(res)
                if (res.status == 0) {
                    this.showUnderLog = true
                    this.successShow = true
                    this.getTicket(id)
                } else {
                    if(res.message=='您不是沉睡客户'){
                       this.$message({
                            message: '很抱歉，您未符合本次活动资格',
                            type: 'warning',
                        });

                    }else{
                        this.$message({
                            message: res.message,
                            type: 'warning',
                        });
                    }
                   
                }
            })
        },

        // 计算时间差值
        constdiffInDays(date1, date2) {
            const data2 = new Date().getTime()

            const data1 = new Date(date1 + 8 * 3600000).getTime();
            console.log(this.getDateChange(data1), this.getDateChange(data2))
            let data = (data2 - data1)
            return Math.floor(data / (24 * 3600 * 1000))

        },
        // 时间戳转时间
        getDateChange(date) {
            var t = new Date(date).toLocaleString();
            return t;
        },
        // 发放包赔劵
        getTicket(id) {
            sendTicket({ activityid: id }).then(res => {
                console.log(res)
            })
        },
        selectlogin(type) {
            this.actives = type
            this.isNumber = false
            this.form.phone = ''
            this.form.code = ''

        },

        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },

        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度

            let scrollY = window.scrollY; //获取滚动后的高
            if (this.scroll > 90 && !this.isApp) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }


        },


        // ----------------------------登录注册
        selectAccount() {
            this.isNumber = true
        },
        selectAccount1() {
            this.isNumber = false
        },

        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                if (this.actives == 1) {
                    this.handleRegister().then((res) => {
                        console.log('-------------------', res)
                        this.loginDialog = false

                        localStorage.setItem('token', res.Token);
                        localStorage.setItem('account', res.account);

                        this.userKey = localStorage.getItem('token');
                        this.loginStatus=false
                        this.getCountdown()




                    }).catch(() => {
                    })
                } else {
                    const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


                    // 手机号登录
                    var params = {
                        isSmsLogin: 1,
                        account: form.phone,
                        password: encryptCBC(form.code),
                        clientId: this.guid,
                        fromType: isWap ? 'wap' : 'pc',
                    }

                    postLogin(params).then((res) => {
                        console.log('-----------', res, res.account)
                        this.loginDialog = false
                        setToken(res.Token)
                        localStorage.setItem('token', res.Token);
                        localStorage.setItem('account', res.account);

                        this.userKey = localStorage.getItem('token');
                        this.loginStatus = false

                        this.getCountdown()



                    });
                }

            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 账号密码登录
        submit1(form) {
            if (form.phone && form.password) {

                const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


                //账号密码登录
                // 手机号登录
                var params = {

                    account: form.phone,
                    password: encryptCBC(form.password),
                    clientId: this.guid,
                    fromType: isWap ? 'wap' : 'pc',
                }

                postLogin(params).then((res) => {
                    console.log('-----------', res, res.account)
                    this.loginDialog = false
                    setToken(res.Token)
                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('account', res.account);
                    this.userinfo = res.jfUser
                    this.userKey = localStorage.getItem('token');
                    this.loginStatus = false

                    this.getCountdown()



                });
            }

            else {
                this.$message({
                    message: '请输入手机号/交易账号和密码！',
                    type: 'warning',
                });
            }
        },
        goback() {
            window.location.href = window.location.origin

        },

        // 关闭参与活动
        closeDialog() {
            this.showUnderLog = !this.showUnderLog
        },

        // 关闭登录注册弹框
        closeHistory() {
            this.loginDialog = !this.loginDialog
        }

    },

    computed: {
        ...mapState("common", {
            live800UrlUc: 'live800UrlUc',
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;


    .tabbar {
        width: 100%;
        background-color: #ffffff;

        img {
            margin: 20px 50px;
            width: 130px;
        }
    }

    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
        height: 600px;
        // padding-top: 75px;
        cursor: pointer;
    }

    .banners {
        display: none;
        cursor: pointer;
    }

    .btncount {
        position: absolute;
        top: 63%;
        left: 28%;
        width: 25%;
        height: 100px;
        z-index: 20;
        // background: red;
    }

    .count {
        position: absolute;
        top: 62%;
        left: 28%;
    }

    .top-list {
        // width: 100%;
        display: block;
        position: absolute;
        top: 26vw;
        left: 24%;

        img {
            cursor: pointer;
        }

        .times {
            // background: red;
            position: absolute;
            bottom: 4%;
            left: 22%;
            height: 46px;
            font-size: 30px;
            line-height: 43px;
            font-weight: 700;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                width: 46px;
                height: 46px;

                border-radius: 8px;
                background: #67B300;
                color: #FFD906;
                text-align: center;
                line-height: 43px;

            }
        }
    }

    .tps {
        position: absolute;
        bottom: -1%;
        left: 24%;
    }

    .top-list1 {

        display: none;
        position: absolute;
        bottom: -2vw;
        left: 20vw;

        img {
            width: 80%;
            height: auto;
            cursor: pointer;
        }

        color: #FFF83A;
        font-size: 13px;
        line-height: 18px;

        .times {
            position: absolute;
            bottom: 32%;
            left: 29%;

        }

        .hour,
        .minute,
        .second {
            margin-right: 4px;
        }


    }

    .tp {
        position: absolute;
        bottom: -2vw;
        left: 13vw;
    }

    .tp1 {
        position: absolute;
        bottom: -2vw;
        left: 13vw;
    }

    .times1 {
        position: absolute;
        bottom: 33%;
        left: 29%;
            width: 43%;
                display: flex;
                justify-content: space-between;

        .hour,
        .minute,
        .second {
            margin-right: 8px;
        }
    }



    .top-box{
        position: relative;
        width: 100%;
    }
    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background: url(/subject/careFree/bg.png) no-repeat;
        background-size: 100% 100%;

        .parent-container {
            display: flex;
            justify-content: center;
            align-items: center;

            .dujia {
                margin-top: 130px;
            }
        }

        .part {
            // max-width: 1400px;
            width: 73%;
            margin: 0 auto;
            padding: 9% 13% 10%;


            .part1 {
                box-sizing: border-box;
                // width: 1204px;
                // height: 1497px;
                max-width: 1204px;
                padding: 15% 6% 10%;

                background: url(/subject/careFree/bg1.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 auto;
                display: block;


                .img-box1 {
                    display: flex;

                    justify-content: space-between;
                    align-items: flex-end;
                    margin-bottom: 40px;

                    div {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        span {
                            color: #FA482E;
                            font-size: 36px;
                            font-weight: 700;
                            line-height: 50px;
                            margin-bottom: 20px;
                        }

                        img {
                            width: 338px;
                            height: auto;
                        }

                    }

                    div:nth-child(2) {
                        span {
                            margin-bottom: 0;
                        }
                    }
                }

                .cont {
                    margin: 0 auto;
                }


                .neirong {

                    display: flex;
                    flex-direction: column;
                    margin: 0 auto;


                }

                .cont {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        margin-top: 72px;
                    }
                }

                .neirong img:nth-child(1) {
                    width: 362px;
                    height: 40px;
                    margin: 58px 0 41px 0;
                }

                .neirong img:nth-child(3) {
                    width: 856px;
                    height: 110px;
                    margin: 76px 0;

                }

                .anniu {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    margin-top: 35px;
                    cursor: pointer;

                    .anniu-div {
                        width: 312px;
                        height: 94px;
                        background: url(/subject/careFree/request.png) no-repeat center;
                        background-size: 100%;
                        margin-right: 18px;
                    }
                }

            }

            .wappart1 {
                display: none;
            }

            .part2 {

                max-width: 1204px;
                margin: 0 auto;
                margin-top: 155px;
                padding: 16% 8% 10%;
                background: url(/subject/careFree/bg2.png) no-repeat center;
                background-size: 100% 100%;
                background-position: center;
                box-sizing: border-box;

                // /* 填充整个小div */
                // .clearfix::after {
                //     content: "";
                //     display: table;
                //     clear: both;
                // }
                .step {
                    width: 100%;
                    height: auto;
                }

                .progress {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 38px 0 44px;

                    &-circle {
                        background: url(/subject/careFree/circle.png) no-repeat;
                        background-size: 100% 100%;
                        position: relative;
                        width: 318px;
                        height: 176px;
                    }

                    &-cont {
                        font-size: 18px;
                        line-height: 26px;
                        color: #333;
                        margin-left: 80px;

                        span {
                            color: #FF8439;
                            font-weight: 600;
                        }
                    }
                }

                .ruleActive {
                    display: flex;
                    flex-direction: column;
                    font-size: 20px;
                    line-height: 36px;
                    color: #333;
                    margin-top: 93px;

                    p {
                        font-weight: 600;
                        margin-top: 40px;
                    }
                }

                .detailTable {
                    width: 60%;
                    box-sizing: border-box;

                    // margin: 0 auto;
                    margin: 23px 0 25px;

                    /deep/ .has-gutter {
                        background: linear-gradient(to right, #FA2314, #DB2C23);

                        tr {
                            background: none;

                            th {

                                text-align: center;
                                font-size: 20px !important;
                            }
                        }
                    }

                    /deep/ .el-table__row {
                        height: 89px;
                    }

                    /deep/ .el-table__row--striped {
                        height: 80px;
                    }

                    /deep/ .el-table__row td:nth-child(1) {

                        color: #222 !important;
                        font-weight: 600 !important;
                        font-size: 20px !important;
                    }

                    /deep/ .el-table__row td:nth-child(2) {

                        color: #222 !important;
                        font-weight: 600 !important;
                        font-size: 20px !important;
                    }

                    /deep/ .el-table__row td:nth-child(3) {

                        color: #333 !important;
                        font-size: 20px !important;
                        font-weight: 600 !important;


                    }

                    /deep/ .el-table_7_column_20 {

                        color: #FA2314 !important;



                    }

                    /deep/ .el-table .cell {
                        white-space: pre-line;
                    }

                    ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                        background: #fff;
                    }

                    ::v-deep .el-table__header-wrapper {
                        border-collapse: collapse;
                        border: none;
                    }

                }

                /deep/ .el-table__header-wrapper {
                    background: #c7180b !important;
                }

                .anniu {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    margin-top: 35px;
                    cursor: pointer;

                    .anniu-div {
                        width: 312px;
                        height: 94px;
                        background: url(/subject/careFree/request.png) no-repeat center;
                        background-size: 100%;
                        margin-right: 18px;
                    }
                }
            }

            .wappart2 {
                display: none;
            }

        }
    }







    /deep/ .el-dialog__header {
        display: none !important;
    }

    /deep/ .el-dialog__body {


        border: none !important;
        background: none !important;
    }

    // 次数不足弹框
    .underlog {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        .closes {
            cursor: pointer;
            margin-top: 44px;
        }

        position: relative;
        position: fixed;
        top: 37%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 466px;

        background: url(/subject/careFree/bg3.png) no-repeat;
        background-size: 100% 100%;

        padding: 80px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;

        .conts {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;

            span {
                color: #FF6609;
                font-weight: 600;
                text-decoration: underline;
            }

            .tits {
                color: #000;
                font-weight: 600;
            }

            .success {
                width: 157px;
                height: 156px;
                position: absolute;
                top: -23%;
                left: 30%;
            }

            .fail {
                width: 105px;
                height: 105px;
                position: absolute;
                top: -14%;
                left: 40%;
            }

            div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 30px;

                img {
                    width: 184px;
                    height: 68px;
                }

                .know {
                    border: 1px solid #FF8439;
                    width: 180px;
                    height: 64px;
                    color: #FF5805;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    margin-top: 0;
                    margin-left: 20px;
                }
            }
        }

        .tit {
            margin: 30px 0 72px;
        }

        .title {
            margin: 42px 0 31px;
        }




    }




    .loginDialogs {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/ .el-dialog__body {


            border: none !important;
            width: 332px !important;
            height: 150px !important;
            background: none !important;
        }

        // ----------------登录-----------
        .login {

            margin: 0 auto;

            background: url(/subject/careFree/bg3.png) no-repeat;
            background-size: 100% 100%;
            border-radius: 10px;
            padding: 120px 0 40px;

            width: 432px;


            position: relative;

            .logintitle {
                position: absolute;
                width: 38%;
                top: 5%;
                left: 32%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                font-size: 28px;
                line-height: 40px;
                color: #000;

                div {
                    display: flex;
                    flex-direction: column;
                }

                .commons {
                    color: #FF630E;

                    font-weight: 600;
                }

                .line {
                    background: #FFD906;
                    width: 60px;
                    height: 6px;
                    border-radius: 3px;
                }
            }

            .logxiadan {
                width: 70%;
                margin: 0 auto;
                margin-bottom: 10px;

                img {
                    width: 100%;
                }
            }

            .interactive {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                input:focus {
                    outline: none;
                }

                input {
                    width: 80%;
                    height: 3vw;
                    background: #F3F3F3;
                    border: 1px solid #fff;
                    border-radius: 10px;
                    font-size: 16px;
                    text-indent: 25px;
                    list-style: none;
                    border: 1px solid #e6e6e6;
                }

                .codeBox {
                    width: 80%;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 16px 0 26px 0;

                    input {
                        width: 100%;
                    }

                    span {
                        width: 160px;
                        height: 3.2vw;
                        line-height: 3.2vw;
                        font-size: 16px;
                        border-radius: 10px;
                        background: linear-gradient(to bottom, #ffefcc, #ffc994);
                        width: 142px;


                        background: #FF5A09;

                        text-align: center;
                        color: #fff;
                        position: absolute;
                        top: 0vw;
                        right: 0px;
                        cursor: pointer;
                    }
                }

                .loginBtn {
                    width: 20%;
                    cursor: pointer;
                    position: relative;
                    top: 15px;
                }

                .titleLogin {
                    line-height: 28px;
                    font-size: 20px;
                    color: #FF9019;
                    font-weight: 700;
                    cursor: pointer;

                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    justify-content: start;
                    width: 80%;

                    img {
                        margin-left: 6px;
                    }
                }
            }


            .buttom {
                width: 240px;
                height: 54px;

                border-radius: 8px;
                text-align: center;
                line-height: 54px;
                color: #fff;
                font-size: 22px;
                font-weight: 700;

                img {
                    width: 100%;
                    height: 100%;
                }

                margin-bottom: 10px;
            }

        }


    }



}


//--------------------------110----------------------
@media screen and (min-width: 1745px) and (max-width: 1897px) {
    .box {
        .top-list {
            // width: 100%;
            display: block;
            position: absolute;
            top: 28vw;
            left: 24%;

        }

        .tps {
            position: absolute;
            bottom: 0%;
            left: 24%;
        }
    }
}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1745px) {
    .box {
        .top-list {
            // width: 100%;
            display: block;
            position: absolute;
            top: 32vw;
            left: 24%;

        }

        .tps {
            position: absolute;
            bottom: 0%;
            left: 24%;
        }
    }
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {

        .top-list {
            // width: 100%;
            display: block;
            position: absolute;
            top: 39vw;
            left: 24%;

        }

        .tps {
            position: absolute;
            top: 88%;
            left: 24%;
        }

        .content .part .part1 .img-box1 div img {
            width: 238px;
            height: auto;
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .btncount {
            position: absolute;
            top: 30%;
            left: 20%;
            width: 70%;
            height: 60px;
            z-index: 20;

        }

        .count {
            position: absolute;
            top: 30%;
            left: 20%;
        }



        .navBarFixed {
            position: fixed;
            top: 0;
            z-index: 999;
        }

        .banner {
            width: 100%;

            display: none;
            // padding-top: 75px;
        }

        .banners {
            display: block;
            width: 100%;
        }

        .top-list {
            display: none;

        }

        .top-list1 {
            display: block;
        }

        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/careFree/wap/bg.png) no-repeat;
            background-size: 100% 100%;

            .parent-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .dujia {
                    margin-top: 130px;
                }
            }

            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;

                .part1 {
                    display: none;
                }

                .wappart1 {
                    display: block;
                    box-sizing: border-box;


                    padding: 18% 4% 10%;

                    background: url(/subject/careFree/wap/bg1.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;

                    .part-list {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        .lists {
                            width: 50%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            color: #FA482E;
                            font-size: 16px;
                            line-height: 36px;
                            font-weight: 600;

                            img {
                                width: 80%;
                                height: auto;
                            }


                        }

                        .lists1 {
                            display: flex;
                            align-items: center;


                            color: #FD6204;
                            font-size: 14px;
                            line-height: 36px;
                            font-weight: 600;

                            img {
                                width: 20px;
                                height: 17px;
                            }
                        }
                    }





                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-top: 20px;

                        .anniu-div {
                            width: 40%;
                            height: 78px;
                            background: url(/subject/careFree/wap/request.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }

                        .anniu-img {
                            width: 40%;

                        }
                    }

                }

                .part2 {
                    display: none;
                }

                .wappart2 {

                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    padding: 22% 10% 10%;
                    background: url(/subject/careFree/wap/bg2.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }

                    .step {
                        width: 100%;
                        margin: 0 auto;
                        height: auto;
                    }

                    .progress {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        img {
                            width: 80%;
                            height: 132px;
                            margin: 0 auto;
                        }

                        &-cont {
                            font-size: 13px;
                            line-height: 18px;
                            color: #333;
                            margin: 25px 0 27px;

                            .titles {
                                margin-top: 20px;
                            }

                            span {
                                color: #FF8314;
                                font-weight: 600;
                            }
                        }
                    }

                    h2 {
                        font-size: 14px;
                        line-height: 18pxs;
                    }

                    .ruleActive {
                        display: flex;
                        flex-direction: column;
                        font-size: 12px;
                        line-height: 24px;
                        color: #333;
                        margin-top: 20px;

                        p {
                            font-weight: 600;
                            margin-top: 20px;
                        }
                    }

                    .detailTable {
                        width: 100%;
                        box-sizing: border-box;

                        margin: 0 auto;
                        margin: 20px 0;

                        /deep/ .has-gutter {
                            tr {
                                background: linear-gradient(to right, #FA2314, #DB2C23);

                            }
                        }

                        /deep/ .has-gutter {
                            background: linear-gradient(to right, #FA2314, #DB2C23);

                            tr {
                                background: none;

                                th {

                                    text-align: center;
                                    font-size: 12px !important;
                                }
                            }
                        }

                        /deep/ .el-table__row {
                            height: 40px;
                        }

                        /deep/ .el-table__row--striped {
                            height: 40px;
                        }

                        /deep/ .el-table__row td:nth-child(1) {

                            color: #222 !important;

                            font-size: 12px !important;
                        }

                        /deep/ .el-table__row td:nth-child(2) {

                            color: #222 !important;

                            font-size: 12px !important;
                        }

                        /deep/ .el-table__row td:nth-child(3) {

                            color: #222 !important;
                            font-size: 12px !important;




                        }

                        /deep/ .el-table_7_column_20 {

                            color: #FA2314 !important;




                        }

                        /deep/ .el-table .cell {
                            white-space: pre-line;
                        }

                        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                            background: #fff;
                        }

                        ::v-deep .el-table__header-wrapper {
                            border-collapse: collapse;
                            border: none;
                        }

                    }

                    /deep/ .el-table__header-wrapper {
                        background: #c7180b !important;

                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;


                        .anniu-div {
                            width: 40%;
                            height: 78px;
                            background: url(/subject/careFree/wap/request.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }

                        .anniu-img {
                            width: 40%;

                        }
                    }
                }


            }
        }





        .underlogs {
            ::v-deep .underlogs .el-dialog__header {
                display: none !important;
            }

        }

        /deep/ .el-dialog__header {
            display: none !important;
        }

        /deep/ .el-dialog__body {
            background: none !important;

            border: none !important;
            padding: 0 !important;
        }

        // 次数不足弹框
        .underlog {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            .closes {
                cursor: pointer;
                width: 156px;
                height: 42px;
                margin-top: 0;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;

            background: url(/subject/careFree/wap/bg3.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 40px;
            box-sizing: border-box;
            font-size: 18px;
            color: #333;
            font-weight: 500;

            .conts {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: column;

                span {
                    color: #FF6609;
                    font-weight: 600;
                    text-decoration: underline;
                }

                .tits {
                    color: #000;
                    font-weight: 600;
                    font-size: 20px;
                }

                .success {
                    width: 78px;
                    height: 78px;
                    position: absolute;
                    top: -20%;
                    left: 36%;
                }

                .fail {
                    width: 52px;
                    height: 52px;
                    position: absolute;
                    top: -7%;
                    left: 40%;
                }

                div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 30px;

                    img {
                        width: 92px;
                        height: 34px;
                    }

                    .know {

                        width: 90px;
                        height: 32px;
                        color: #FF5805;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }

                .weight {
                    font-size: 20px;
                    font-weight: 600;
                }

            }

            .tit {
                margin: 20px 0 40px;
            }

            .title {
                margin: 42px 0 31px;
            }

        }

        .loginDialogs {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);



            // ----------------登录-----------
            .login {

                margin: 0 auto;

                background: url(/subject/careFree/wap/bg3.png) no-repeat;
                background-size: 100% 100%;
                border-radius: 10px;
                padding: 100px 0 40px;

                width: 294px;
                // height: 220px;

                position: relative;

                .logintitle {
                    position: absolute;
                    width: 38%;
                    top: 5%;
                    left: 32%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    font-size: 18px;
                    line-height: 40px;
                    color: #000;

                    div {
                        display: flex;
                        flex-direction: column;
                    }

                    .commons {
                        color: #FF630E;

                        font-weight: 600;
                    }

                    .line {
                        background: #FFD906;
                        width: 30px;
                        height: 3px;
                        border-radius: 3px;
                    }
                }

                .logxiadan {
                    width: 70%;
                    margin: 0 auto;
                    margin-bottom: 10px;

                    img {
                        width: 100%;
                    }
                }

                .interactive {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;

                    input:focus {
                        outline: none;
                    }

                    input {
                        width: 80%;
                        height: 12vw;

                        background: #F3F3F3;

                        border-radius: 10px;
                        font-size: 14px;
                        text-indent: 25px;
                        list-style: none;
                        // border: 1px solid #e6e6e6;
                    }

                    .codeBox {
                        width: 80%;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 16px 0 26px 0;

                        input {
                            width: 100%;
                        }

                        span {
                            width: 160px;
                            height: 12vw;
                            line-height: 12vw;
                            font-size: 14px;
                            border-radius: 10px;
                            background: linear-gradient(to bottom, #ffefcc, #ffc994);
                            width: 100px;

                            background: #FF5A09;
                            text-align: center;
                            color: #fff;
                            position: absolute;
                            top: 0vw;
                            right: 0px;
                            cursor: pointer;
                        }
                    }

                    .loginBtn {
                        width: 20%;
                        cursor: pointer;
                        position: relative;
                        top: 15px;
                    }

                    .titleLogin {
                        line-height: 28px;
                        font-size: 16px;
                        color: #FF9019;
                        font-weight: 700;
                        cursor: pointer;

                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        justify-content: start;
                        width: 80%;

                        img {
                            margin-left: 6px;
                            width: 20px;
                            height: 14px;
                        }
                    }
                }


                .buttom {
                    width: 240px;
                    height: 54px;

                    border-radius: 8px;
                    text-align: center;
                    line-height: 54px;

                }

            }


        }

    }

}
</style>
